import React, { useEffect, useContext } from 'react';
import { AppContext } from '../../../Store';
import { getTranslations } from '../../../helpers/translations';
import i18n from '../../../../i18n';

export const withTranslations = function(Component) {
	const EnhancedWrapper = function({ ...props }) {
		const [state, dispatch] = useContext(AppContext);

		useEffect(() => {
			const loadTranslations = async () => {
				try {
					const loadedTranslations = await getTranslations(state.locale, dispatch);
					
					if (!loadedTranslations) {
						const errorMessage = 'Could not load translations.';
						console.error(errorMessage, 'state.locale', state.locale);
						dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: errorMessage });
						dispatch({ type: 'SHOW_SERVER_ERROR' });

						return;
					}

					const language = Object.keys(loadedTranslations)[0];

					i18n.addResourceBundle(language, 'translation', loadedTranslations[language].translation);
					i18n.changeLanguage(language);
					dispatch({ type: 'TRANSLATIONS_LOADED' });
					dispatch({ type: 'SET_SITE_LANGUAGE', payload: language });
				} catch (error) {
					console.error('There was an error: ', error);
					dispatch({ type: 'SET_SERVER_ERROR_MESSAGE', payload: 'Something went wrong.' });
					dispatch({ type: 'SHOW_SERVER_ERROR' });
				}
			};

			if (state.locale) {
				loadTranslations();
			}
		}, [dispatch, state.locale]);

		return (
			<Component
				{...props}
			/>
		);
	};
	EnhancedWrapper.displayName = 'wrapperWithTranslations';
	return EnhancedWrapper;
};
